<template>
  <div class="dot-group">
    <DotIndicator
      v-for="index in count"
      :key="index"
      :active="index - 1 === activeIndex"
    />
  </div>
</template>

<script>
import DotIndicator from '@/components/new/atoms/DotIndicator.vue'

export default {
  name: 'DotGroup',
  components: {
    DotIndicator,
  },
  props: {
    count: {
      type: Number,
      default: 1,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped>
.dot-group {
  display: flex;
  height: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/DotGroup.vue